import { lazy } from "react";
import { BASE_PATH } from "context/SiteSettingsContext/utils";
import { ERouteMappingKeys } from "./routeKeys";

export const cameraSecurityRoutes = {
  [ERouteMappingKeys.CAMERA_SECURITY]: {
    id: "camera-security",
    path: "/camera-security",
    components: {
      [BASE_PATH]: lazy(() =>
        import("pages/Sections/CameraSecurity/Overview").then((p) => ({
          default: p.Overview,
        })),
      ),
      bullet: lazy(() =>
        import("pages/Sections/CameraSecurity/Bullet").then((p) => ({
          default: p.Bullet,
        })),
      ),
      "dome-turret": lazy(() =>
        import("pages/Sections/CameraSecurity/DomeTurret").then((p) => ({
          default: p.DomeTurret,
        })),
      ),
      ptz: lazy(() =>
        import("pages/Sections/CameraSecurity/Ptz").then((p) => ({
          default: p.Ptz,
        })),
      ),
    },
  },
};
